import { getSharedDomain, useCookie } from './useCookie';
import { CookieStorageOptions } from '../services/utils/CookieStorage';
import { SystemLanguage } from '../services/enumTranslator/SystemLanguage';
import { Ref } from 'vue';

export const LANGUAGE_COOKIE = 'lendi-language' as const;
const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

/**
 * A composable function to manage the language cookie
 * Uses shared domain (.lendi.pl) so language preference is shared across all subdomains
 * @returns {Ref<SystemLanguage | undefined>} The language cookie reference
 */
export const useLanguageCookie = (): Ref<SystemLanguage | undefined> => {
    const sharedDomain = getSharedDomain();

    const cookieOptions: Partial<CookieStorageOptions> = {
        domain: sharedDomain,
        path: '/',
        sameSite: 'lax'
    };

    return useCookie<SystemLanguage | undefined>(LANGUAGE_COOKIE, ONE_YEAR_IN_SECONDS, cookieOptions);
};

export default useLanguageCookie;
